// 引流获客路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/drainage',
  component: Layout,
  children: [
    {
      path: 'channelCode',
      component: () => import('@/view/drainage/channelCode'),
      name: '渠道活码'
    },
    {
      path: 'channelCode/:id',
      component: () => import('@/view/drainage/channelCodeEdit'),
      name: '渠道活码编辑'
    },
    {
      path: 'officialAccount',
      component: () => import('@/view/drainage/officialAccount'),
      name: '公众号引流'
    },
    {
      path: 'formActivity',
      component: () => import('@/view/formActivity/index'),
      name: '表单活动'
    },
    {
      path: 'formActivity/new/:id',
      component: () => import('@/view/formActivity/new'),
      name: '新建或编辑表单活动'
    },
    {
      path: 'formActivity/data/:id',
      component: () => import('@/view/formActivity/data'),
      name: '活动数据统计'
    },
    {
      path: 'formTemplate',
      component: () => import('@/view/formTemplate/index'),
      name: '表单管理'
    }
  ]
}
